// AIMS PWA - online/offline status hook.
//
// Reflects navigator.onLine and updates on the browser's online/offline events.
// Used to branch cache-vs-server (offline inspection capture, sync triggers).
// navigator.onLine is a coarse signal (it means "has a network interface", not
// "the API is reachable"), but it's the right cue for the no-signal-on-site case
// this feature targets; genuine request failures are handled by falling back to
// cache at each call site.

import { useEffect, useState } from 'react';

export default function useOnlineStatus() {
  const [online, setOnline] = useState(
    typeof navigator !== 'undefined' && typeof navigator.onLine === 'boolean' ? navigator.onLine : true
  );

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  return online;
}
